<div class="bw-dialog audit-dialog">

  <lib-page-header screenName="Audit Trail" [title]="data.entityName + ' · ID ' + data.entityId" backTo="">
    <mat-icon icon>policy</mat-icon>
    <ng-container stats *ngIf="dataSetSize() > 0">
      <div class="page-header-stat">
        <mat-icon>history</mat-icon>
        <span class="stat-value">{{ dataSetSize() }}</span>
        <span class="stat-label">Records</span>
      </div>
    </ng-container>
    <ng-container actions>
      <!-- Heavy-export controls (XLSX / CSV / print / maximize) intentionally
           omitted: the audit-report page already covers them for filtered
           queries. The per-row dialog stays a focused viewer. Close X is
           auto-rendered by lib-page-header in MatDialog. -->
    </ng-container>
  </lib-page-header>

  <!-- Body -->
  <div class="bw-body">

    <div class="audit-empty" *ngIf="dataSource().length === 0 && proggressBarMode() === 'determinate'">
      <mat-icon class="audit-empty-icon">history_toggle_off</mat-icon>
      <span class="audit-empty-title">No audit records</span>
      <span class="audit-empty-sub">No changes have been recorded for this item yet.</span>
    </div>

    <div class="scroll-container" *ngIf="dataSource().length > 0">
      <table mat-table [dataSource]="dataSource()" class="audit-table" matSort
             (matSortChange)="sortData($event)">

        <!-- Timestamp -->
        <ng-container matColumnDef="create-timestamp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="createTimestamp">Timestamp</th>
          <td mat-cell *matCellDef="let e" class="ts-cell">{{ e.createTimestamp | date:'MMM d, yyyy · h:mm:ss a' }}</td>
        </ng-container>

        <!-- Username -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="username">User</th>
          <td mat-cell *matCellDef="let e">
            <div class="user-cell">
              <mat-icon class="user-icon">account_circle</mat-icon>
              <span>{{ e.username }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</th>
          <td mat-cell *matCellDef="let e">
            <span class="action-badge" [ngClass]="getActionClass(e.action)">{{ e.action }}</span>
          </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</th>
          <td mat-cell *matCellDef="let e" class="desc-cell">{{ e.description }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="star" stickyEnd>
          <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
          <td mat-cell *matCellDef="let e" class="action-cell">
            <button mat-icon-button (click)="onViewDetails(e)" matTooltip="View Details" aria-label="View details" class="view-btn">
              <mat-icon>view_comfy</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="audit-row"></tr>
      </table>
    </div>

    <div class="paginator-row" *ngIf="dataSource().length > 0">
      <div class="page-size-chips">
        <span class="page-size-label">Show</span>
        <span *ngFor="let opt of pageSizeOptions"
              class="page-size-chip"
              [class.active]="pageSize === opt"
              (click)="pageSize = opt; handlePageEvent({pageIndex: 0, pageSize: opt, length: dataSetSize()})">
          {{ opt }}
        </span>
      </div>
      <mat-paginator
        #paginator
        (page)="handlePageEvent($event)"
        [length]="dataSetSize()"
        [pageSize]="pageSize"
        [showFirstLastButtons]="showFirstAndLast"
        [pageSizeOptions]="pageSizeOptions"
        [hidePageSize]="true"
        [pageIndex]="page.pageNumber"
        aria-label="Select page" />
    </div>
  </div>

</div>
